type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};
/**
 * TimelineIntroCardIcon — a frame with a solid bar on its LEFT edge: the card
 * that opens the video. Pairs with `TimelineEndCardIcon` (bar on the right).
 * Timeline block glyph only; transport controls keep `ForwardToEndIcon`.
 */
const TimelineIntroCardIcon = ({
  width = '14',
  height = '14',
  strokeColor = 'currentColor',
}: Props) => (
  <svg width={width} height={height} viewBox="0 0 14 14" fill="none">
    <rect
      x="1.5"
      y="2.5"
      width="11"
      height="9"
      rx="1.5"
      stroke={strokeColor}
      strokeWidth="1"
    />
    <rect x="1.5" y="2.5" width="3" height="9" rx="1" fill={strokeColor} />
  </svg>
);

export default TimelineIntroCardIcon;
